import { render, staticRenderFns } from "./Arrangement.vue?vue&type=template&id=4a57b05c&scoped=true&"
import script from "./Arrangement.vue?vue&type=script&lang=js&"
export * from "./Arrangement.vue?vue&type=script&lang=js&"
import style0 from "./Arrangement.vue?vue&type=style&index=0&id=4a57b05c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a57b05c",
  null
  
)

export default component.exports